export default __webpack_public_path__ + "static/media/SearThumb.19975e9e.png";